/* eslint-disable @typescript-eslint/camelcase */
import InfiniteScroll from 'react-infinite-scroll-component'
import { connect } from 'react-redux'
import { getCookies } from 'cookies-next'
import { Array, Record, Number, Function, Static, String } from 'runtypes'
import * as Sentry from '@sentry/nextjs'

import authenticationApi from '../../api/authentication'
import Content from '../../components/Content/Content'
import FullWidthAdBanner from '../../components/Advertisement/FullWidthAdBanner/FullWidthAdBanner'
import PostSizeS from '../../components/Content/PostSizeS/PostSizeS'
import RightSidePanel from '../../components/Content/RightSidePanel/RightSidePanel'
import NewsApi from '../../api/news'
import CategoryApi from '../../api/categories'
import { actions, initializeStore } from '../../store'
import { Category as CategoryType, PostFromServer } from '../../types'
import BannerApi from '../../api/banners'
import SearchResults from '../../components/Content/SearchResults/SearchResults'
import { getFileFullPath, isPostNew } from '../../utils/Helpers'
import { SearchResponse } from '../../types/posts'
import PostSizeL from '../../components/Content/PostSizeL/PostSizeL'
import PostSizeXS from '../../components/Content/PostSizeXS/PostSizeXS'
import { useEffect, useState } from 'react'
import SideVerticalAdvertisementBar from '../../components/Advertisement/SideVerticalAdvertisementBar/SideVerticalAdvertisementBar'
import EmptyCategory from '../../components/Content/EmptyCategory/EmptyCategory'
import { renderAds } from '../index'

export const CategoryPage = Record({
  posts: Array(PostFromServer),
  selectedCategory: String,
  category: CategoryType,
  total: Number,
  page: Number,
})
export type CategoryPage = Static<typeof CategoryPage>

const CategoryProps = Record({
  selectedCategory: String,
  categoryPage: CategoryPage,
  updateCategoryPage: Function,
  searchResultsPagination: SearchResponse,
})

export type CategoryProps = Static<typeof CategoryProps>

const Category = ({
  categoryPage,
  updateCategoryPage,
  searchResultsPagination,
}: CategoryProps): JSX.Element => {
  const [screenWidth, setScreenWidth] = useState(1920)

  useEffect(() => {
    setScreenWidth(window.innerWidth)
  }, [])

  useEffect(() => {
    localStorage.setItem('page', 'category')
  }, [])

  const fetchMorePosts = async () => {
    const perPage = 20
    const response = await NewsApi.getNewsByCategoryId(
      categoryPage.category.id,
      categoryPage.page + 1,
      perPage
    )
    updateCategoryPage(response.data)
  }

  const renderPosts = () => {
    if (!categoryPage.posts.length) return <EmptyCategory />
    return (
      <InfiniteScroll
        dataLength={categoryPage.posts.length}
        next={fetchMorePosts}
        hasMore={categoryPage.posts.length < categoryPage.total}
        loader={null}
        className="overflow-hidden"
      >
        <div>
          {searchResultsPagination?.data &&
          searchResultsPagination.data.length ? (
            <SearchResults />
          ) : (
            categoryPage.posts
              .sort((a: PostFromServer, b: PostFromServer) => {
                return (
                  (a.category_primary_position != null
                    ? a.category_primary_position
                    : Infinity) -
                  (b.category_primary_position != null
                    ? b.category_primary_position
                    : Infinity)
                )
              })
              .map((post, i) => {
                if (i % 7 === 0 || i % 7 === 3 || i % 7 === 5) {
                  return (
                    <div className="float-left w-full" key={i}>
                      <PostSizeL
                        key={i}
                        post={{
                          title: post.name,
                          subtitle: post.subtitle,
                          url: getFileFullPath(post.featured_image),
                          slug: post.slug,
                          chiron_url: post.chiron_url,
                          chiron_name: post.chiron_name,
                          isNew: isPostNew(post.is_new, post.published_at),
                          hasVideo:
                            post.content?.includes('<video') ||
                            post.content?.includes(
                              '<iframe src="https://www.youtube.com'
                            ),
                        }}
                        showTopMargin={i !== 0}
                        category={categoryPage.category}
                        subCategory={null}
                      />
                    </div>
                  )
                } else if (i % 7 === 1) {
                  return (
                    <div
                      key={i}
                      className="float-left mt-2.5 w-full px-2.5 md:px-0 bg-white"
                    >
                      <div className="flex">
                        <div className="flex-1 mr-1 w-1/2">
                          <PostSizeXS
                            post={{
                              title: post.name,
                              subtitle: post.subtitle,
                              url: getFileFullPath(post.featured_image),
                              slug: post.slug,
                              chiron_url: post.chiron_url,
                              chiron_name: post.chiron_name,
                              isNew: isPostNew(post.is_new, post.published_at),
                              hasVideo:
                                post.content?.includes('<video') ||
                                post.content?.includes(
                                  '<iframe src="https://www.youtube.com'
                                ),
                            }}
                            category={categoryPage.category}
                            subCategory={null}
                          />
                        </div>
                        <div className="flex-1 bg-white ml-1 w-1/2">
                          {categoryPage.posts[i + 1] !== undefined ? (
                            <PostSizeXS
                              post={{
                                title: categoryPage.posts[i + 1]['name'],
                                subtitle: categoryPage.posts[i + 1]['subtitle'],
                                url: getFileFullPath(
                                  categoryPage.posts[i + 1]['featured_image']
                                ),
                                slug: categoryPage.posts[i + 1]['slug'],
                                chiron_url:
                                  categoryPage.posts[i + 1]['chiron_url'],
                                chiron_name:
                                  categoryPage.posts[i + 1]['chiron_name'],
                                isNew: isPostNew(
                                  categoryPage.posts[i + 1]['is_new'],
                                  categoryPage.posts[i + 1]['published_at']
                                ),
                                hasVideo:
                                  categoryPage.posts[i + 1][
                                    'content'
                                  ]?.includes('<video') ||
                                  categoryPage.posts[i + 1][
                                    'content'
                                  ]?.includes(
                                    '<iframe src="https://www.youtube.com'
                                  ),
                              }}
                              category={categoryPage.category}
                              subCategory={null}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )
                } else if (i % 7 === 4 || i % 7 === 6) {
                  return (
                    <div key={i}>
                      <div className="float-left w-full">
                        <div>
                          <PostSizeS
                            key={i}
                            post={{
                              title: post.name,
                              subtitle: post.subtitle,
                              url: getFileFullPath(post.featured_image),
                              slug: post.slug,
                              chiron_url: post.chiron_url,
                              chiron_name: post.chiron_name,
                              isNew: isPostNew(post.is_new, post.published_at),
                              hasVideo:
                                post.content?.includes('<video') ||
                                post.content?.includes(
                                  '<iframe src="https://www.youtube.com'
                                ),
                            }}
                            category={categoryPage.category}
                            subCategory={null}
                            imagePosition={i % 7 === 4 ? 'right' : 'left'}
                          />
                        </div>
                      </div>
                      {i % 7 === 6 && renderAds(i, screenWidth)}
                    </div>
                  )
                }
              })
          )}
        </div>
      </InfiniteScroll>
    )
  }

  return (
    <div className="flex mx-auto page">
      <Content>
        <FullWidthAdBanner />
        <div className="flex mt-5">
          {searchResultsPagination?.data &&
          searchResultsPagination.data.length ? (
            <SearchResults />
          ) : (
            renderPosts()
          )}
          {screenWidth > 900 ? <RightSidePanel /> : null}
        </div>
      </Content>
      <SideVerticalAdvertisementBar />
    </div>
  )
}

export async function getServerSideProps(context) {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=180, stale-while-revalidate=200'
  )
  const reduxStore = initializeStore()
  const categoriesResponse = await CategoryApi.getCategories()
  const category = categoriesResponse.data.find(
    (category) =>
      category.name.toLowerCase().replace(/-/g, ' ') ===
      context.params.category.toLowerCase().replace(/-/g, ' ')
  )
  const response = await NewsApi.getNewsByCategoryId(category.id, 1)
  const categoryResponse = response.data
  let banners = []
  try {
    const bannersResponse = await BannerApi.getBannersByCategoryId(category.id)
    banners = bannersResponse.data
  } catch (e) {
    banners = []
    Sentry.captureException(e)
  }

  const authResponse = await authenticationApi.getUser(
    getCookies(context, 'access_token')
  )
  return {
    props: {
      initialReduxState: {
        ...reduxStore.getState(),
        categoryPage: {
          posts: categoryResponse?.data.length ? categoryResponse?.data : [],
          category: category,
          total: categoryResponse?.pagination.total,
          page: categoryResponse?.pagination.current_page,
        },
        selectedCategory: category,
        banners,
        isUserLoggedIn: authResponse.data.id ? true : false,
        user: authResponse.data.id ? authResponse.data : null,
      },
    },
  }
}

const mapStateToProps = (state) => {
  return {
    categoryPage: state.categoryPage,
    searchResultsPagination: state.searchResultsPagination,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateCategoryPage: (response) => {
      dispatch({
        type: actions.UPDATE_CATEGORY_PAGE,
        payload: {
          categoryPage: {
            posts: response?.data.length ? response?.data : [],
            total: response?.pagination.total,
            page: response?.pagination.current_page,
          },
        },
      })
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Category)
